import _regenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import { DEBUG_LANGUAGE, PRIVILEGES, DATE_PICKER_LOCALES } from "@/utils/const";
import { updateDateLocale } from "@/utils/util";
import { loadLanguageAsync } from "@/plugins/i18n";
import network from "@/utils/network";
import Menu from "primevue/menu";
import Button from "primevue/button";
import { usePrimeVue } from "primevue/config";
export default {
  name: "LanguageSelector",
  // eslint-disable-next-line vue/no-reserved-component-names
  components: {
    Button: Button,
    Menu: Menu
  },
  data: function data() {
    return {
      primevue: usePrimeVue()
    };
  },
  computed: {
    languages: function languages() {
      var baseLanguages = [{
        value: "hu",
        label: this.$tf("profile.language.hu|Magyar")
      }, {
        value: "en",
        label: this.$tf("profile.language.en|Angol")
      }];
      var extLanguages = [];
      if (this.$store.getters["session/hasAuthority"](PRIVILEGES.MISC.BETA.BETA)) {
        extLanguages.push({
          value: DEBUG_LANGUAGE,
          label: this.$tf("".concat(DEBUG_LANGUAGE, "|").concat(DEBUG_LANGUAGE))
        });
      }
      return baseLanguages.concat(extLanguages);
    },
    selectedLangOption: function selectedLangOption() {
      var saved = this.$i18n.locale;
      return this.languages.find(function (o) {
        return o.value === saved;
      });
    }
  },
  methods: {
    changeLanguage: function changeLanguage(newLang) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var axios, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              updateDateLocale(newLang);
              _context.n = 1;
              return loadLanguageAsync(newLang);
            case 1:
              _context.n = 2;
              return network.connection();
            case 2:
              axios = _context.v;
              _context.p = 3;
              _context.n = 4;
              return axios.patch("census/lang/mine/".concat(newLang));
            case 4:
              _this.primevue.config.locale.dayNames = DATE_PICKER_LOCALES[newLang].dayNames;
              _this.primevue.config.locale.dayNamesShort = DATE_PICKER_LOCALES[newLang].dayNamesShort;
              _this.primevue.config.locale.dayNamesMin = DATE_PICKER_LOCALES[newLang].dayNamesMin;
              _this.primevue.config.locale.monthNames = DATE_PICKER_LOCALES[newLang].monthNames;
              _this.primevue.config.locale.monthNamesShort = DATE_PICKER_LOCALES[newLang].monthNamesShort;
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.log("Failed changing language");
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[3, 5]]);
      }))();
    },
    toggleMenu: function toggleMenu(event) {
      this.$refs.menu.toggle(event);
    }
  },
  mounted: function mounted() {
    this.changeLanguage(this.$i18n.locale);
  }
};